import React, { useEffect, useContext, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import '../Header/HeaderStyle.css';
import { AuthDataContext } from '../Common/AuthenticateUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSignOutAlt, faUser, faFileAlt, faFilePdf, faFileContract, faWallet,
    faBuilding, faUserTag, faUserCog, faSitemap, faQrcode, faIdCardAlt,
    faTasks, faHouseDamage, faNetworkWired, faUserShield, faBars, faBell, faStopwatch,
    faMapMarkerAlt, faPrint, faBoxOpen, faPaste, faMapMarkedAlt, faTruckMoving, faFileInvoice,
    faExchangeAlt, faThumbtack, faPhoneSquareAlt, faIdCard, faChartBar, faArrowRight, faArrowLeft,
    faEnvelopeOpenText,
    faBook,
    faPaintBrush,
    faStepForward,
    faHandshake
} from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from "react-tooltip";
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
//import moment from 'moment';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Pages from '../Common/AppPages';
import moment from 'moment';

const PasswordChange = {
    OldPassword: "",
    NewPassword: "",
    ConfirmPassword: ""
}

const AppHeader = () => {
    const themeContextData = useContext(ThemeContext);

    let history = useHistory();
    const contextData = useContext(AuthDataContext);
    const [theme, setShowTheme] = useState("none");
    // const [ShowLanguage, setShowLanguage] = useState("none");
    // const [Language, setLanguage] = useState("en");
    const [loginSession, setloginSession] = useState("none");
    const [themeMode, setThemeMode] = useState(localStorage.getItem("quotationTheme") ? localStorage.getItem("quotationTheme") : "default");
    // eslint-disable-next-line
    const [AlreadyLoggedIn, setAlreadyLoggedIn] = useState(true);
    // eslint-disable-next-line
    // const [AlreadyLoggedOut, setAlreadyLoggedOut] = useState(false);
    // const [UserSession, setUserSession] = useState({});
    const [ShowHideQuotationMenu, setShowHideQuotationMenu] = useState("none");
    const [ShowHideEnquiryMenu, setShowHideEnquiryMenu] = useState("none");
    const [ShowHideDashMenu, setShowHideDashMenu] = useState("none");
    const [ShowHideAdminMenu, setShowHideAdminMenu] = useState("none");

    const [ShowHideInvoiceMenu, setShowHideInvoiceMenu] = useState("none");

    const [ShowHideTrackMenu, setShowHideTrackMenu] = useState("none");
    const [ShowHideLRMenu, setShowHideLRMenu] = useState("none");
    const [ShowHideServReqMenu, setShowHideServReqMenu] = useState("none");
    const [displayChangePassword, setdisplayChangePassword] = useState("none");
    const [ChangePassword, setChangePassword] = useState(PasswordChange);
    const [PasswordStrength, setPasswordStrength] = useState(0);
    const [ExpiryAge, setExpiryAge] = useState({});
    const [Arrow, setArrow] = useState("");


    //var roleID = 0;
    var LoggedInCompanyCity = "";
    var LoggedInUserName = "";
    var RolePages = [];
    var RoleName = "";
    var CompanyDetails = null;
    var IsUserPasswordReset = false;
    var LogoFileName = "";
    var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
    if (userData !== null) {
        var parsedUserData = JSON.parse(userData);
        // roleID = JSON.parse(userData).Role.ID;
        LoggedInUserName = parsedUserData.FirstName + " " + parsedUserData.LastName;
        LoggedInCompanyCity = parsedUserData.Organization.length > 0 ? `MFI ${parsedUserData.Organization[0].City}` : "";
        RolePages = parsedUserData.RoleAccess;
        RoleName = parsedUserData.Role[0].Name;
        CompanyDetails = parsedUserData.Organization.length > 0 ? parsedUserData.Organization[0] : null;
        IsUserPasswordReset = parsedUserData.IsNewUser === 1 ? true : false;
        LogoFileName = parsedUserData.Organization[0].Logo;
    }

    useEffect(() => {
        // if (localStorage.getItem("defaultlanguage") !== null &&
        //     localStorage.getItem("defaultlanguage") !== "") {
        //     setLanguage(localStorage.getItem("defaultlanguage"));
        // }

        ExpandMenuBasedonPageOnLoad();
        ExpiryAgeInfo();
        // FetchLogInSession(moment().startOf('day').format('MM/DD/YYYY, HH:mm:ss'), moment().endOf('day').format('MM/DD/YYYY, HH:mm:ss'));
        if (IsUserPasswordReset) {
            OnPasswordChangeClick();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showHideQuotationMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideQuotationMenu((ShowHideQuotationMenu === "none") ? "block" : "none");
        setShowHideEnquiryMenu("none");
        setShowHideDashMenu("none");
        setShowHideAdminMenu("none");
        //setShowHideBatchMenu("none");
        setShowHideInvoiceMenu("none");
        //setShowHideLeavesMenu("none");
        setShowHideTrackMenu("none");
        setShowHideLRMenu("none");
        setShowHideServReqMenu("none");
    };

    const showHideEnquiryMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideEnquiryMenu((ShowHideEnquiryMenu === "none") ? "block" : "none");
        setShowHideQuotationMenu("none");
        setShowHideDashMenu("none");
        setShowHideAdminMenu("none");
        //setShowHideBatchMenu("none");
        setShowHideInvoiceMenu("none");
        //setShowHideLeavesMenu("none");
        setShowHideTrackMenu("none");
        setShowHideLRMenu("none");
        setShowHideServReqMenu("none");
    };

    const showHideDashBoardMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideDashMenu((ShowHideDashMenu === "none") ? "block" : "none");
        setShowHideQuotationMenu("none");
        setShowHideEnquiryMenu("none");
        setShowHideAdminMenu("none");
        //setShowHideBatchMenu("none");
        setShowHideInvoiceMenu("none");
        //setShowHideLeavesMenu("none");
        setShowHideTrackMenu("none");
        setShowHideLRMenu("none");
        setShowHideServReqMenu("none");
    };

    const showHideAdminMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideAdminMenu((ShowHideAdminMenu === "none") ? "block" : "none");

        setShowHideDashMenu("none");
        setShowHideQuotationMenu("none");
        setShowHideEnquiryMenu("none");
        //setShowHideBatchMenu("none");
        setShowHideInvoiceMenu("none");
        //setShowHideLeavesMenu("none");
        setShowHideTrackMenu("none");
        setShowHideLRMenu("none");
        setShowHideServReqMenu("none");
    };

    const arrowClick = (type) => {
        var element = document.getElementsByClassName(type);
        if (element !== null && element.length > 0) {
            element[0].classList.toggle("active");
            if (element[0].classList.contains("active")) {
                setArrow(type);
            }
            else {
                setArrow("");
            }
        }
    };

    const InActiveMenus = () => {
        var elements = document.querySelectorAll(".menuHeadingStyle");
        for (var i = 0; i < elements.length; i++) {
            if (elements[i] !== null) {
                elements[i].classList.remove("active");
            }
        }

    }

    // const showHideBatchMenu = () => {
    //     setShowHideBatchMenu((ShowHideBatchMenu === "none") ? "block" : "none");
    //     setShowHideAdminMenu("none");
    //     //setShowHideDashMenu("none");
    //     setShowHideQuotationMenu("none");
    //     setShowHideEnquiryMenu("none");
    //     setShowHideInvoiceMenu("none");
    //     setShowHideLeavesMenu("none");
    //     setShowHideTrackMenu("none");
    //     setShowHideLRMenu("none");
    //     setShowHideServReqMenu("none");
    // };

    const showHideInvoiceMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideInvoiceMenu((ShowHideInvoiceMenu === "none") ? "block" : "none");
        // setShowHideBatchMenu("none");
        setShowHideAdminMenu("none");
        setShowHideDashMenu("none");
        setShowHideQuotationMenu("none");
        setShowHideEnquiryMenu("none");
        // setShowHideLeavesMenu("none");
        setShowHideTrackMenu("none");
        setShowHideLRMenu("none");
        setShowHideServReqMenu("none");
    };

    // const showHideLeavesMenu = () => {
    //     setShowHideLeavesMenu((ShowHideLeavesMenu === "none") ? "block" : "none");
    //     setShowHideInvoiceMenu("none");
    //     //setShowHideBatchMenu("none");
    //     setShowHideAdminMenu("none");
    //     //setShowHideDashMenu("none");
    //     setShowHideQuotationMenu("none");
    //     setShowHideEnquiryMenu("none");
    //     setShowHideTrackMenu("none");
    //     setShowHideLRMenu("none");
    //     setShowHideServReqMenu("none");
    // };

    const showHideTrackMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideTrackMenu((ShowHideTrackMenu === "none") ? "block" : "none");
        // setShowHideLeavesMenu("none");
        setShowHideInvoiceMenu("none");
        // setShowHideBatchMenu("none");
        setShowHideAdminMenu("none");
        setShowHideDashMenu("none");
        setShowHideQuotationMenu("none");
        setShowHideEnquiryMenu("none");
        setShowHideLRMenu("none");
        setShowHideServReqMenu("none");
    };

    const showHideLRMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideLRMenu((ShowHideLRMenu === "none") ? "block" : "none");
        setShowHideTrackMenu("none");
        // setShowHideLeavesMenu("none");
        setShowHideInvoiceMenu("none");
        // setShowHideBatchMenu("none");
        setShowHideAdminMenu("none");
        setShowHideDashMenu("none");
        setShowHideQuotationMenu("none");
        setShowHideEnquiryMenu("none");
        setShowHideServReqMenu("none");
    };

    const showHideServReqMenu = () => {
        InActiveMenus();
        setArrow("");

        setShowHideServReqMenu((ShowHideServReqMenu === "none") ? "block" : "none");
        setShowHideTrackMenu("none");
        // setShowHideLeavesMenu("none");
        setShowHideInvoiceMenu("none");
        //setShowHideBatchMenu("none");
        setShowHideAdminMenu("none");
        setShowHideDashMenu("none");
        setShowHideQuotationMenu("none");
        setShowHideEnquiryMenu("none");
    };

    const showHideTheme = () => {
        setloginSession("none");
        //setShowLanguage("none");
        setShowTheme((theme === "none") ? "block" : "none");
    };

    const hideChangePassword = () => {
        setdisplayChangePassword("none");
    };

    const OnPasswordChangeClick = () => {
        setdisplayChangePassword("block");
    };

    const ExpiryAgeInfo = () => {
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        var parsedUserData = userData ? JSON.parse(userData) : null;
        let ExpiryDate = (parsedUserData && parsedUserData.ExpiryDate !== undefined) ? moment(parsedUserData.ExpiryDate) : null;
        if (ExpiryDate) {
            let FifteenDaysExpiry = moment().add(15, 'days').endOf('day');
            let OneMonthDaysExpiry = moment().add(30, 'days').endOf('day');
            var diffInDays = null;
            if (FifteenDaysExpiry >= ExpiryDate) {
                diffInDays = ExpiryDate.diff(moment(), 'days');
                setExpiryAge({ Color: "red", days: diffInDays.toString() + " days left" });
            }
            else if (OneMonthDaysExpiry >= ExpiryDate) {
                diffInDays = ExpiryDate.diff(moment(), 'days');
                setExpiryAge({ Color: "orange", days: diffInDays.toString() + " days left" });
            }
            else {
                diffInDays = ExpiryDate.diff(moment(), 'days');
                var daysLeftMessage = "";
                if (diffInDays < 0) {
                    daysLeftMessage = "License Expired " + Math.abs(diffInDays) + "days ago";
                    setExpiryAge({ Color: "red", days: daysLeftMessage });
                }
                else {
                    daysLeftMessage = diffInDays.toString() + " days left";
                    setExpiryAge({ Color: "green", days: daysLeftMessage });
                }
            }
        }
    };

    const onAddNewPassword = (e) => {
        var password = e.target.value;
        var strongRegex = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{6,20}$");
        var mediumRegex = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,20}$");
        if (strongRegex.test(password)) {
            setPasswordStrength(100);
        }
        else if (mediumRegex.test(password)) {
            setPasswordStrength(60);
        }
        else {
            setPasswordStrength(password === "" ? 0 : 10);
        }

        setChangePassword({ ...ChangePassword, [e.target.name]: password });
    };

    const AddPassword = (e) => {
        var password = e.target.value;
        setChangePassword({ ...ChangePassword, [e.target.name]: password });
    };

    const UpdatePassword = () => {
        if (ValidateChangePassword(ChangePassword)) {
            var UserID = userData !== null ? JSON.parse(userData)._id : "";
            if (UserID !== "") {
                Axiosfetch(baseURL + "UpdatePassword", "POST", { ID: UserID, Old: ChangePassword.OldPassword, New: ChangePassword.NewPassword }, PasswordChangeSuccess, Failure);
            }
            else {
                Alert.error("Session Expired. Please Login again.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const PasswordChangeSuccess = (data) => {
        if (data.success) {
            hideChangePassword();
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });


        }
    };

    const ValidateChangePassword = (passwordData) => {
        var errorMsg = "";

        if (PasswordStrength < 100) {
            errorMsg = "Minimum Criteria for password does not match.";
        }
        else if (passwordData.OldPassword === "") {
            errorMsg = "Please enter Old Password";
        }
        else if (passwordData.NewPassword === "") {
            errorMsg = "Please enter New Password";
        }
        else if (passwordData.ConfirmPassword === "") {
            errorMsg = "Please enter Confirm Password";
        }
        else if (passwordData.ConfirmPassword !== passwordData.NewPassword) {
            errorMsg = "New Password and Confirm Password does not match";
        }
        else if (passwordData.ConfirmPassword.length < 6) {
            errorMsg = "Password should have minimum 6 characters.";
        }
        if (errorMsg !== "") {
            Alert.error(errorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            return false;
        }

        return true;
    };

    // const showHideLanguage = () => {
    //     setloginSession("none");
    //     setShowTheme("none");
    //     setShowLanguage(ShowLanguage === "none" ? "block" : "none");
    // };

    const showLoginSession = () => {
        setShowTheme("none");
        //setShowLanguage("none");
        setloginSession((loginSession === "none") ? "block" : "none");
    };

    const ThemeMode = (themeColor) => {
        themeContextData.themeClick(themeColor);
        setThemeMode(themeColor);
        setShowTheme("none");
        setArrow("");
    };

    // const ChangeLanguage = (language) => {
    //     if (localStorage.getItem("defaultlanguage") !== null &&
    //         localStorage.getItem("defaultlanguage") !== "" && localStorage.getItem("defaultlanguage") !== language) {
    //         localStorage.removeItem("defaultlanguage");
    //         localStorage.setItem("defaultlanguage", language);
    //         setLanguage(language);
    //         showHideLanguage();

    //         Alert.success("Language Changed Successfully. Refresh to view the changes", {
    //             position: 'bottom-right',
    //             effect: 'slide',
    //             html: false
    //         });
    //     }
    // };

    // const FetchLogInSession = (start, end) => {
    //     let userID = 0;
    //     if (userData !== null) {
    //         userID = JSON.parse(userData).ID;
    //     }
    //     Axiosfetch(baseURL + "CheckIfLoggedIn", "POST", { UserID: userID, StartDate: start, EndDate: end }, FetchLoginSessionSuccess, Failure);
    // };

    // const FetchLoginSessionSuccess = (data) => {

    //     if (data.length === 0) {
    //         setAlreadyLoggedIn(true);
    //         setAlreadyLoggedOut(false);
    //         setUserSession({});
    //     }
    //     else {
    //         if (data[0].LogOutDate === "Invalid date" || data[0].LogOutDate === null) {
    //             setAlreadyLoggedOut(true);
    //         }
    //         else {
    //             setAlreadyLoggedOut(false);
    //         }

    //         setAlreadyLoggedIn(false);
    //         setUserSession(data[0]);
    //     }
    // };

    const ExpandMenuBasedonPageOnLoad = () => {
        const path = window.location.pathname.replace("/", "");
        if (path !== "") {
            const ConfigList = Pages.ConfigList;
            const EnquiryList = Pages.EnquiryList;
            const QuotationList = Pages.QuotationList;
            const TrackingList = Pages.TrackingList;
            const LRDocList = Pages.LRDocList;
            const ServReqList = Pages.ServReqList;
            const InvoiceList = Pages.InvoiceList;
            const DashBoardList = Pages.DashBoardList;
            if (ConfigList.filter(r => r.Page === path).length > 0) {
                showHideAdminMenu("block");
            }
            else if (EnquiryList.filter(r => r.Page === path).length > 0) {
                setShowHideEnquiryMenu("block");
            }
            else if (QuotationList.filter(r => r.Page === path).length > 0) {
                setShowHideQuotationMenu("block");
            }
            else if (TrackingList.filter(r => r.Page === path).length > 0) {
                setShowHideTrackMenu("block");
            }
            else if (LRDocList.filter(r => r.Page === path).length > 0) {
                setShowHideLRMenu("block");
            }
            else if (ServReqList.filter(r => r.Page === path).length > 0) {
                setShowHideServReqMenu("block");
            }
            else if (InvoiceList.filter(r => r.Page === path).length > 0) {
                setShowHideInvoiceMenu("block");
            }
            else if (DashBoardList.filter(r => r.Page === path).length > 0) {
                setShowHideDashMenu("block");
            }
        }
    }

    // const AddLoginSession = () => {
    //     let userID = 0;
    //     if (userData !== null) {
    //         userID = JSON.parse(userData).ID;
    //         Axiosfetch(baseURL + "AddLogInSession", "POST", { UserID: userID, LogInDate: moment(new Date()).format('MM/DD/YYYY, HH:mm:ss') }, UserLoginSessionSuccess, Failure);
    //     }
    //     else {
    //         Alert.error("Application Error. Please Re-Login and try again", {
    //             position: 'bottom-right',
    //             effect: 'slide',
    //             html: false
    //         });
    //     }
    // };

    // const UserLoginSessionSuccess = (data) => {
    //     setAlreadyLoggedOut(true);
    //     setAlreadyLoggedIn(false);
    //     setUserSession(data);

    //     Alert.success("Session successfully started.", {
    //         position: 'bottom-right',
    //         effect: 'slide',
    //         html: false
    //     });
    // };

    // const AddLogOutSession = () => {
    //     Axiosfetch(baseURL + "AddLogOutSession", "POST", { SessionID: UserSession.SessionID, LogOutDate: moment(new Date()).format('MM/DD/YYYY, HH:mm:ss') }, UserLogOutSessionSuccess, Failure);
    // };

    // const UserLogOutSessionSuccess = (data) => {
    //     setAlreadyLoggedOut(false);
    //     setUserSession(data);

    //     Alert.success("Session successfully ended.", {
    //         position: 'bottom-right',
    //         effect: 'slide',
    //         html: false
    //     });
    // };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const Logout = () => {
        localStorage.setItem("userData", null);
        contextData.logout();
        history.push("/");
    };

    const OnHomeSelect = () => {
        history.push("/Welcome");
    };

    const OnHideMenu = () => {
        let DisplayStyle = document.getElementsByClassName("sidemenu")[0].style.display;

        let element = document.getElementsByClassName("InvoiceTheme");
        if (DisplayStyle === "none" && element !== null && element.length > 0) {
            element[0].classList.add("sidemenu-show");
            element[0].classList.remove("sidemenu-hide");
        }
        else if (element !== null && element.length > 0) {
            element[0].classList.add("sidemenu-hide");
            element[0].classList.remove("sidemenu-show");
        }

        document.getElementsByClassName("sidemenu")[0].style.display = DisplayStyle === "none" ?
            "block" : "none";
        DisplayStyle = DisplayStyle === "none" ? "block" : "none";

        document.getElementsByClassName("InvoiceTheme")[0].style.marginLeft = DisplayStyle === "none" ?
            "1rem" : "4.5rem";
    };

    return (
        <div className={`headerStyle container-fluid ${themeMode}`} style={{ position: "fixed", top: "0", zIndex: "1000" }}>
            <div className="row" style={{ paddingTop: 8, height: 50 }}>
                <div className={`col-md-1 col-sm-1 headernameStyle headercolor cursor ${themeMode}`}>
                    <span className="menu-drawer" style={{ paddingRight: "10px" }} data-tip="Menu">
                        <FontAwesomeIcon icon={faBars} onClick={OnHideMenu} /></span>
                </div>
                <div className={`col-md-5 col-sm-5 left headercolor name headernameStyle cursor ${themeMode}`}>
                    {/* https://mail.google.com/mail/?view=cm&fs=1&to=someone@example.com&cc=someone@ola.com&bcc=someone.else@example.com&su=SUBJECT&body=BODY */}
                    <span style={{ paddingRight: "10px" }} data-tip="Home" onClick={OnHomeSelect}> {process.env.REACT_APP_APPNAME}</span>

                </div>
                <div className={`col-md-4 col-sm-5 headercolor ${themeMode}`} onClick={showLoginSession} style={{ textAlign: "right", color: "white", fontSize: "20px", position: "relative", cursor: "pointer" }}>
                    <span style={{ paddingRight: "10px" }} data-tip="User Profile">
                        <img style={{ borderRadius: "6px", position: "relative", top: "-2px" }} alt="logo" width="40" height="35"
                            src={`${baseURL}HeaderLogo/${LogoFileName}`}></img>
                    </span>
                    <span className="usernamestyle">{LoggedInCompanyCity}</span>
                    <div className={loginSession === "none" ? "profileStyle hide" : "profileStyle show"}>


                        {CompanyDetails && (<div style={{ textAlign: "center", marginTop: "10px", color: "rgb(0, 85, 130)", cursor: "default" }}>
                            <div>{LoggedInUserName}</div>
                            <hr></hr>
                            <div>{CompanyDetails && CompanyDetails.Name}</div>
                        </div>)}
                        {CompanyDetails && (<div style={{ color: "gray", fontSize: "14px", textAlign: "center", cursor: "default", borderBottom: "1px solid #ccc", paddingBottom: "10px" }}>
                            <span><FontAwesomeIcon style={{ color: "black" }} icon={faMapMarkerAlt} />
                                {CompanyDetails && (<span style={{ paddingLeft: "2px" }}> {CompanyDetails.State}, {CompanyDetails.Country}</span>)}
                            </span>
                        </div>)}
                        <div className={`${themeMode}`} style={{ textAlign: "center", paddingBottom: "6px", color: "white", cursor: "default" }}>
                            {RoleName}
                        </div>
                        <div style={{ height: "1px", backgroundColor: "#ddd" }}></div>
                        <div style={{ textAlign: "center" }}>{(ExpiryAge.days !== undefined ? (<span style={{ color: (ExpiryAge.days !== undefined ? ExpiryAge.Color : "green") }}>
                            <span><FontAwesomeIcon style={{ paddingRight: "5px" }} icon={faStopwatch}></FontAwesomeIcon></span>
                            {(ExpiryAge.days !== undefined ? ExpiryAge.days : "")}</span>) : "-")}
                        </div>
                        <div style={{ textAlign: "center", padding: "6px", margin: "10px 0", fontSize: "15px", color: "rgb(0, 85, 130)" }}>
                            <span className={`btnStyleWithoutFill`} onClick={OnPasswordChangeClick}>Change Password</span>
                        </div>
                    </div>
                </div>
                <div className={`col-md-1 col-sm-4 headercolor ${themeMode}`} style={{ textAlign: "right", color: "white", position: "relative", fontSize: "20px" }}>
                    <span style={{ paddingRight: "10px", cursor: "pointer" }} onClick={showHideTheme} data-tip="Theme">
                        <FontAwesomeIcon style={{ color: "#ed2839" }} icon={faPaintBrush} /></span>
                    {/* <span style={{ paddingRight: "10px", cursor: "pointer" }} onClick={showHideLanguage} data-tip="Language"> <FontAwesomeIcon icon={faLanguage} /></span> */}

                    <div className={theme === "none" ? "profileStyle themestyle hide" : "profileStyle themestyle show"}>
                        <div onClick={() => ThemeMode("default")} className="themeNodeStyle">
                            <div style={{ backgroundColor: "#005582", borderRadius: "50px", width: "18px", height: "18px", margin: "0.5rem" }}></div>
                        </div>
                        <div onClick={() => ThemeMode("dark")} className="themeNodeStyle">
                            <div style={{ cursor: "pointer", backgroundColor: "black", borderRadius: "50px", width: "18px", height: "18px", margin: "0.5rem" }}></div>
                        </div>
                        <div onClick={() => ThemeMode("blue")} className="themeNodeStyle">
                            <div style={{ cursor: "pointer", backgroundColor: "#24bbc0", borderRadius: "50px", width: "18px", height: "18px", margin: "0.5rem" }}></div>
                        </div>
                        <div onClick={() => ThemeMode("loggray")} className="themeNodeStyle">
                            <div style={{ cursor: "pointer", backgroundColor: "#30655E", borderRadius: "50px", width: "18px", height: "18px", margin: "0.5rem" }}></div>
                        </div>
                    </div>

                    {/* <div className={ShowLanguage === "none" ? "hide" : "show"} style={{ position: "absolute", left: "75%", backgroundColor: "white", border: "1px solid rgb(0, 85, 130)" }}>
                        <div onClick={() => ChangeLanguage("en")} className="languageNodeStyle" style={{ color: (Language === "en" ? "#005582" : "black"), borderBottom: "1px solid #ccc" }}>
                            English
                        </div>
                        <div onClick={() => ChangeLanguage("de")} className="languageNodeStyle" style={{ color: (Language === "de" ? "#005582" : "black") }}>
                            German
                        </div>
                    </div> */}
                </div>
                <div className={`col-md-1 col-sm-2 headercolor ${themeMode}`} style={{ textAlign: "right" }}>
                    <span className="iconSize IconWidth logoutStyle" onClick={Logout} data-tip="Logout"><FontAwesomeIcon icon={faSignOutAlt} /></span>
                </div>
            </div>
            <div className="row">
                <div className="sidemenu" style={{ width: (Arrow !== "" ? "210px" : "72px"), scrollbarWidth: "none" }}>
                    {RolePages.filter(r => r.PageName === "CompanyInfo" || r.PageName === "Users" || r.PageName === "Organization"
                        || r.PageName === "Roles" || r.PageName === "RoleAccess" || r.PageName === "MerchantCode"
                        || r.PageName === "Wallet" || r.PageName === "IDCard" || r.PageName === "IBA" ||
                        r.PageName === "EBusinessCard" || r.PageName === "EmailConfig" || r.PageName === "PartnerDirectory" ||
                        r.PageName === "EventRecords").length > 0 &&
                        (<div onClick={showHideAdminMenu} className={`menuHeadingStyle config ${themeMode}`} data-tip="Configuration Menu">Config</div>)}
                    <div style={{ position: "relative" }} className={`adminMenu${ShowHideAdminMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("config")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "config" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "CompanyInfo").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/CompanyInfo" ? "menuActive" : themeMode + "Color"}`} to='/CompanyInfo'>
                                    <div style={{ fontSize: "1.7rem", paddingLeft: "2px" }} className="iconSize IconWidth font-size-15rem" data-tip="Company Info"><FontAwesomeIcon icon={faBuilding} /></div>
                                    <span className="link_text">Company Info</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "Users").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Users" ? "menuActive" : themeMode + "Color"}`} to='/Users'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Users"><FontAwesomeIcon icon={faUser} /></div>
                                    <span className="link_text">Users</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "Organization").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Organization" ? "menuActive" : themeMode + "Color"}`} to='/Organization'>
                                    <div style={{ fontSize: "1.4rem" }} className="iconSize IconWidth" data-tip="Organizations"><FontAwesomeIcon icon={faSitemap} /></div>
                                    <span className="link_text">Organization</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "Roles").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Roles" ? "menuActive" : themeMode + "Color"}`} to='/Roles'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="User Roles">
                                        <FontAwesomeIcon icon={faUserCog} /></div>
                                    <span className="link_text">Roles</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "RoleAccess").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/RoleAccess" ? "menuActive" : themeMode + "Color"}`} to='/RoleAccess'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Role Access">
                                        <FontAwesomeIcon icon={faUserTag} /></div>
                                    <span className="link_text">Role Access</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "MerchantCode").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/MerchantCode" ? "menuActive" : themeMode + "Color"}`} to='/MerchantCode'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Merchant Codes">
                                        <FontAwesomeIcon icon={faQrcode} /></div>
                                    <span className="link_text">Merchant Code</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "Wallet").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Wallet" ? "menuActive" : themeMode + "Color"}`} to='/Wallet'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Manage Wallet">
                                        <FontAwesomeIcon icon={faWallet} /></div>
                                    <span className="link_text">Manage Wallet</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "IDCard").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/IDCard" ? "menuActive" : themeMode + "Color"}`} to='/IDCard'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="User ID Card"><FontAwesomeIcon icon={faIdCardAlt} /></div>
                                    <span className="link_text">ID Card</span> </Link></li>)}
                            {RolePages.filter(r => r.PageName === "EBusinessCard").length > 0 && (<li>
                                <Link target="_blank" className={`sideMenuThemeDefault ${window.location.pathname === "/EBusinessCard" ? "menuActive" : themeMode + "Color"}`} to={'/EBusinessCard/' + (parsedUserData._id ? parsedUserData._id : "")}>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="E-Business Card"><FontAwesomeIcon icon={faIdCard} /></div>
                                    <span className="link_text">E-Business Card</span></Link></li>)}
                            {RolePages.filter(r => r.PageName === "IBA").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/IBA" ? "menuActive" : themeMode + "Color"}`} to='/IBA'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="IBA Configuration"><FontAwesomeIcon icon={faUserShield} /></div>
                                    <span className="link_text">IBA</span> </Link></li>)}
                            {RolePages.filter(r => r.PageName === "PartnerDirectory").length > 0 && (<li>
                                <Link target="_blank" className={`sideMenuThemeDefault ${window.location.pathname === "/PartnerDirectory" ? "menuActive" : themeMode + "Color"}`} to='/PartnerDirectory'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Partner Directory"><FontAwesomeIcon icon={faBook} /></div>
                                    <span className="link_text">Partner Directory</span> </Link></li>)}
                            {RolePages.filter(r => r.PageName === "EmailConfig").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/EmailConfig" ? "menuActive" : themeMode + "Color"}`} to='/EmailConfig'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Email Configuration"><FontAwesomeIcon icon={faEnvelopeOpenText} /></div>
                                    <span className="link_text">Email Template</span> </Link></li>)}
                            {RolePages.filter(r => r.PageName === "EventRecords").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/EventRecords" ? "menuActive" : themeMode + "Color"}`} to='/EventRecords'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Event Records"><FontAwesomeIcon icon={faHandshake} /></div>
                                    <span className="link_text">Event Records</span> </Link></li>)}
                        </ul>
                    </div>

                    {(RolePages.filter(r => r.PageName === "NewEnquiry" || r.PageName === "ManageEnquiry" || r.PageName === "Survey"
                        || r.PageName === "ManageSurvey").length > 0) && (<div onClick={showHideEnquiryMenu} className={`menuHeadingStyle enquiry ${themeMode}`} data-tip="Enquiry Menu">Enquiry</div>)}
                    {/* <div className={`batchMenu${ShowHideEnquiryMenu}`}> */}
                    <div style={{ position: "relative" }} className={`enquiryMenu${ShowHideEnquiryMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("enquiry")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "enquiry" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "NewEnquiry").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/NewEnquiry" ? "menuActive" : themeMode + "Color"}`} to='/NewEnquiry'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="New Enquiry">
                                        <FontAwesomeIcon icon={faPrint} /></div>
                                    <span className="link_text">New Enquiry</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "ManageEnquiry").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/ManageEnquiry" ? "menuActive" : themeMode + "Color"}`} to='/ManageEnquiry'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="View Enquiries">
                                        <FontAwesomeIcon icon={faPrint} /></div>
                                    <span className="link_text">Manage Enquiry</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "Survey").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Survey" ? "menuActive" : themeMode + "Color"}`} to='/Survey'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Goods Survey">
                                        <FontAwesomeIcon icon={faBoxOpen} /></div>
                                    <span className="link_text">Survey</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "ManageSurvey").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/ManageSurvey" ? "menuActive" : themeMode + "Color"}`} to='/ManageSurvey'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Manage Survey">
                                        <FontAwesomeIcon icon={faTasks} /></div>
                                    <span className="link_text">Manage Survey</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "Insurance").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Insurance" ? "menuActive" : themeMode + "Color"}`} to='/Insurance'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Manage Insurance">
                                        <FontAwesomeIcon icon={faHouseDamage} /></div>
                                    <span className="link_text">Insurance</span></Link>
                            </li>)}
                        </ul>
                    </div>

                    {(RolePages.filter(r => r.PageName === "CreateQuotation" || r.PageName === "GenerateQuotation" ||
                        r.PageName === "QuotationRecords").length > 0) && (<div onClick={showHideQuotationMenu} className={`menuHeadingStyle quote ${themeMode}`} data-tip="Quotation Menu">Quote</div>)}
                    {/* <div className={`quotationMenu${ShowHideQuotationMenu}`}> */}
                    <div style={{ position: "relative" }} className={`quotationMenu${ShowHideQuotationMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("quote")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "quote" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "CreateQuotation").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/CreateQuotation" ? "menuActive" : themeMode + "Color"}`} to='/CreateQuotation'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Create Quotation"><FontAwesomeIcon icon={faFileContract} /></div>
                                    <span className="link_text">Create Quotation</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "GenerateQuotation").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/GenerateQuotation" ? "menuActive" : themeMode + "Color"}`} to='/GenerateQuotation'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Generate Quotation PDF"><FontAwesomeIcon icon={faFilePdf} /></div>
                                    <span className="link_text">Generate Quotation</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "QuotationRecords").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/QuotationRecords" ? "menuActive" : themeMode + "Color"}`} to='/QuotationRecords'>
                                    <div style={{ fontSize: "1.7rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Quotation Record"><FontAwesomeIcon icon={faFileAlt} /></div>
                                    <span className="link_text">Quotation Records</span></Link>
                            </li>)}
                        </ul>
                    </div>

                    {RolePages.filter(r => r.PageName === "CreateLR").length > 0 && (<div onClick={showHideLRMenu} className={`menuHeadingStyle lr ${themeMode}`} data-tip="LR Menu">LR</div>)}
                    {/* <div className={`batchMenu${ShowHideLRMenu}`}> */}
                    <div style={{ position: "relative" }} className={`batchMenu${ShowHideLRMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("lr")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "lr" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "CreateLR").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/CreateLR" ? "menuActive" : themeMode + "Color"}`} to='/CreateLR'>
                                    <div style={{ fontSize: "1.4rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Create LR Document">
                                        <FontAwesomeIcon icon={faPaste} /></div>
                                    <span className="link_text">Create LR</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "GenerateLR").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/GenerateLR" ? "menuActive" : themeMode + "Color"}`} to='/GenerateLR'>
                                    <div style={{ fontSize: "1.4rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Generate LR Document">
                                        <FontAwesomeIcon icon={faTruckMoving} /></div>
                                    <span className="link_text">Generate LR</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "LRRecords").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/LRRecords" ? "menuActive" : themeMode + "Color"}`} to='/LRRecords'>
                                    <div style={{ fontSize: "1.4rem" }} className="iconSize IconWidth font-size-2rem" data-tip="LR Records">
                                        <FontAwesomeIcon icon={faFileAlt} /></div>
                                    <span className="link_text">LR Records</span></Link>
                            </li>)}
                        </ul>
                    </div>
                    {RolePages.filter(r => r.PageName === "Invoice" || r.PageName === "InvoiceApproval" ||
                        r.PageName === "GenerateInvoice" || r.PageName === "PaymentLogs" || r.PageName === "CreditNotes"
                        || r.PageName === "InvoiceRecords" || r.PageName === "InvoiceHistory").length > 0 &&
                        (<div onClick={showHideInvoiceMenu} className={`menuHeadingStyle invoice ${themeMode}`} data-tip="Invoice Menu">Invoice</div>)}
                    {/* <div className={`invoiceMenu${ShowHideInvoiceMenu}`}> */}
                    <div style={{ position: "relative" }} className={`invoiceMenu${ShowHideInvoiceMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("invoice")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "invoice" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "Invoice").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Invoice" ? "menuActive" : themeMode + "Color"}`} to='/Invoice'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Create Invoice">
                                        <FontAwesomeIcon icon={faFileInvoice} />
                                    </div>
                                    <span className="link_text">Create Invoice</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "GenerateInvoice").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/GenerateInvoice" ? "menuActive" : themeMode + "Color"}`} to='/GenerateInvoice'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Generate Invoice">
                                        <FontAwesomeIcon icon={faFilePdf} />
                                    </div>
                                    <span className="link_text">Generate Invoice</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "InvoiceRecords").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/InvoiceRecords" ? "menuActive" : themeMode + "Color"}`} to='/InvoiceRecords'>
                                    <div style={{ fontSize: "1.5rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Invoice Record">
                                        <FontAwesomeIcon icon={faFileAlt} />
                                    </div>
                                    <span className="link_text">Invoice Record</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "CreditNotes").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/CreditNotes" ? "menuActive" : themeMode + "Color"}`} to='/CreditNotes'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-15rem" data-tip="Credit Notes">
                                        <FontAwesomeIcon icon={faExchangeAlt} />
                                    </div>
                                    <span className="link_text">Credit Notes</span></Link>
                            </li>)}
                        </ul>
                    </div>
                    {(RolePages.filter(r => r.PageName === "InternalReq" || r.PageName === "IServRecords").length > 0) && (<div onClick={showHideServReqMenu} className={`menuHeadingStyle IntServ ${themeMode}`} data-tip="Internal Service Request">IServ.</div>)}
                    {/* <div className={`servReqMenu${ShowHideServReqMenu}`}> */}
                    <div style={{ position: "relative" }} className={`servReqMenu${ShowHideServReqMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("IntServ")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "IntServ" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "InternalReq").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/InternalReq" ? "menuActive" : themeMode + "Color"}`} to='/InternalReq'>
                                    <div className="iconSize IconWidth font-size-15rem" data-tip="Internal Request"><FontAwesomeIcon icon={faNetworkWired} /></div>
                                    <span className="link_text">Internal Request</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "IServRecords").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/IServRecords" ? "menuActive" : themeMode + "Color"}`} to='/IServRecords'>
                                    <div className="iconSize IconWidth font-size-15rem" data-tip="Delivery Records">
                                        <FontAwesomeIcon icon={faFileAlt} /></div>
                                    <span className="link_text">Delivery Records</span></Link>
                            </li>)}
                        </ul>
                    </div>

                    {RolePages.filter(r => r.PageName === "AdminDashBoard" || r.PageName === "PartnerDashBoard" || r.PageName === "Alert").length > 0 && (<div onClick={showHideDashBoardMenu} className={`menuHeadingStyle board ${themeMode}`} data-tip="Dashboard Menu">Board</div>)}
                    {/* <div className={`batchMenu${ShowHideDashMenu}`}> */}
                    <div style={{ position: "relative" }} className={`boardMenu${ShowHideDashMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("board")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "board" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "AdminDashBoard").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/AdminDashBoard" ? "menuActive" : themeMode + "Color"}`} to='/AdminDashBoard'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Admin DashBoard">
                                        <FontAwesomeIcon icon={faUserShield} /></div>
                                    <span className="link_text">Admin DashBoard</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "PartnerDashBoard").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/PartnerDashBoard" ? "menuActive" : themeMode + "Color"}`} to='/PartnerDashBoard'>
                                    <div style={{ fontSize: "1.4rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Partner DashBoard">
                                        <FontAwesomeIcon icon={faUser} /></div>
                                    <span className="link_text">Partner DashBoard</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "Alert").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/Alert" ? "menuActive" : themeMode + "Color"}`} to='/Alert'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Configure Alerts">
                                        <FontAwesomeIcon icon={faBell} /></div>
                                    <span className="link_text">Alerts</span></Link>
                            </li>)}
                        </ul>
                    </div>

                    {RolePages.filter(r => r.PageName === "TrackingDetails" || r.PageName === "ManageTrip" || r.PageName === "TrackRecords"
                        || r.PageName === "TrackReport" || r.PageName === "TrackLimits").length > 0 && (<div onClick={showHideTrackMenu} className={`menuHeadingStyle track ${themeMode}`} data-tip="Tracking Menu">Track</div>)}
                    {/* <div className={`trackMenu${ShowHideTrackMenu}`}> */}
                    <div style={{ position: "relative" }} className={`trackMenu${ShowHideTrackMenu} ${Arrow !== "" ? themeMode : ""}`}>
                        <ul>
                            <div className={`menu-arrow ${Arrow !== "" ? "exp" : (themeMode + "Color")}`}>
                                <div onClick={() => arrowClick("track")} className="hover-style arrow-left"><FontAwesomeIcon icon={Arrow === "track" ? faArrowLeft : faArrowRight}></FontAwesomeIcon></div>
                            </div>
                            {RolePages.filter(r => r.PageName === "TrackingDetails").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/TrackingDetails" ? "menuActive" : themeMode + "Color"}`} to='/TrackingDetails'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Tracking Details">
                                        <FontAwesomeIcon icon={faMapMarkedAlt} /></div>
                                    <span className="link_text">Tracking Details</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "ManageTrip").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/ManageTrip" ? "menuActive" : themeMode + "Color"}`} to='/ManageTrip'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Manage Trip">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} /></div>
                                    <span className="link_text">Manage Trip</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "TrackRecords").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/TrackRecords" ? "menuActive" : themeMode + "Color"}`} to='/TrackRecords'>
                                    <div style={{ fontSize: "1.3rem" }} className="iconSize IconWidth font-size-2rem" data-tip="Track Records">
                                        <FontAwesomeIcon icon={faThumbtack} /></div>
                                    <span className="link_text">Track Records</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "TrackReport").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/TrackReport" ? "menuActive" : themeMode + "Color"}`} to='/TrackReport'>
                                    <div style={{ fontSize: "1.3rem", marginBottom: "10px" }} className="iconSize IconWidth font-size-2rem" data-tip="Member Tracking Report">
                                        <FontAwesomeIcon icon={faChartBar} /></div>
                                    <span className="link_text">Track Report</span></Link>
                            </li>)}
                            {RolePages.filter(r => r.PageName === "TrackLimits").length > 0 && (<li>
                                <Link className={`sideMenuThemeDefault ${window.location.pathname === "/TrackLimits" ? "menuActive" : themeMode + "Color"}`} to='/TrackLimits'>
                                    <div style={{ fontSize: "1.3rem", marginBottom: "10px" }} className="iconSize IconWidth font-size-2rem" data-tip="Member Tracking Limits">
                                        <FontAwesomeIcon icon={faStepForward} /></div>
                                    <span className="link_text">Track Limits</span></Link>
                            </li>)}

                        </ul>
                    </div>
                </div>
            </div>
            <div className="row">
                <footer className={`footer ${themeMode}`}>
                    <div className="footerContainer" style={{ display: "flex", justifyContent: "space-between" }}>
                        <a data-tip="Contact MFI Team." style={{ color: "white", paddingLeft: "10px" }} rel="noopener noreferrer" href="https://mail.google.com/mail/?view=cm&fs=1&to=ms@moversfederation.org" target="_blank">
                            <span><FontAwesomeIcon icon={faPhoneSquareAlt} />
                                <span style={{ paddingLeft: "5px" }}>MSTeam MFI</span>
                            </span>
                        </a>
                        <p className="copyright">© Movers Federation of India {process.env.REACT_APP_DEPLOY_YEAR}</p>
                        <p className="version">{process.env.REACT_APP_VERSION}</p>
                    </div>
                </footer>
            </div>
            <ReactTooltip></ReactTooltip>
            <div id="myModaChangePassword" className="modal" style={{ display: displayChangePassword }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${themeMode}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Change Password</span>
                        <span className="close" onClick={hideChangePassword}>&times;</span>
                    </div>

                    <div className="row" style={{ padding: "0 20px 0 20px" }}>
                        <table className="table tableTDWidthStyle">
                            <tbody>
                                <tr style={{ borderBottom: "1px solid #ccc" }}>
                                    <td>
                                        <h5>Old Password<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="password" name="OldPassword"
                                            onChange={(e) => AddPassword(e)} className="form-control"
                                            value={ChangePassword.OldPassword}></input>
                                    </td>
                                </tr>
                                <tr style={{ borderBottom: "1px solid #ccc" }}>
                                    <td>
                                        <h5>New Password<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="password" name="NewPassword"
                                            className="form-control" onChange={(e) => onAddNewPassword(e)}
                                            value={ChangePassword.NewPassword}></input>
                                    </td>
                                </tr>
                                <tr style={{ borderBottom: "1px solid #ccc" }}>
                                    <td>
                                        <h5>Confirm Password<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input style={{ border: (ChangePassword.NewPassword !== "" ? (ChangePassword.NewPassword === ChangePassword.ConfirmPassword ? "1px solid green" : "1px solid red") : "1px solid #ccc") }}
                                            type="password" name="ConfirmPassword"
                                            onChange={(e) => AddPassword(e)} className="form-control"
                                            value={ChangePassword.ConfirmPassword}></input>
                                    </td>
                                </tr>
                                <tr style={{ borderBottom: "1px solid #ccc" }}>
                                    <td>
                                        <h5>Strength</h5>
                                    </td>
                                    <td>
                                        <div><progress id="pswdStrength" value={PasswordStrength} max="100"></progress>
                                            <span style={{ paddingLeft: "20px", verticalAlign: "super", color: (PasswordStrength === 100 ? "green" : (PasswordStrength === 60) ? "orange" : "red") }}>
                                                {PasswordStrength === 100 ? "Strong" : (PasswordStrength === 60) ? "Meduim" : "Weak"}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "left" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12" style={{ color: "red" }}>
                                                <div>1. At least 1 Upper Case and Lower Case Character</div>
                                                <div>2. At least 1 Special characters @$!%*?&]</div>
                                                <div>3. At least a Number [0-9] </div>
                                                <div>4. Minimum 6 Characters</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeMode}Focus`} onClick={UpdatePassword}>Save</button>
                                                <button type="button" className="btn btn-default" onClick={hideChangePassword}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(AppHeader);